<mat-card appearance="outlined" class="step-card">
  <mat-card-header>
    <mat-card-title>
      {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.TITLE_V2' | translate }}
    </mat-card-title>
  </mat-card-header>
  @if (loading$ | async) {
    <div>
      <div class="stencil-shimmer col col-xs-4 calendar-slug-shimmer"></div>
      <div class="stencil-shimmer col col-xs-4 calendar-slug-shimmer"></div>
    </div>
  }
  <mat-card-content>
    @if ((loading$ | async) === false) {
      <div>
        <div>
          @if (description$ | async; as description) {
            <div class="subtitle">{{ description }}</div>
          }
          <glxy-form-field [prefixText]="linkPrefix$ | async" [bottomSpacing]="'none'">
            <input [formControl]="slugFormControl" name="slug" />
            @if (slugChanged$$ | async) {
              <button mat-icon-button matSuffix (click)="revertSlug()">
                <mat-icon>undo</mat-icon>
              </button>
            }
            @if (slugFormControl.invalid) {
              <glxy-error>
                @if (slugFormControl.hasError('taken') || slugFormControl.hasError('pattern')) {
                  @if (slugFormControl.hasError('taken')) {
                    {{ slugFormControl.errors.taken }}
                  }
                  @if (slugFormControl.hasError('pattern')) {
                    {{ slugFormControl.errors.pattern }}
                  }
                } @else {
                  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.VALIDATION.GENERIC_ERROR' | translate }}
                }
              </glxy-error>
            }
          </glxy-form-field>
        </div>
      </div>
    }

    <div class="form-row form-actions">
      @if ((isSaving$$ | async) === false) {
        <button
        [disabled]="
          (loading$ | async) ||
          slugFormControl.invalid ||
          (disableButtonIfValueUnchanged && this.originalSlug === slugFormControl.value)
        "
          (click)="setSlug(slugFormControl.value)"
          mat-raised-button
          color="primary"
          type="submit"
          data-testid="slug-submit"
          >
          {{ buttonLabel }}
        </button>
      }
      @if (isSaving$$ | async) {
        <div class="spinner-container">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
